import {createRouter, createWebHistory} from 'vue-router'
import {useAuthStore} from "@/stores/auth";

const routes = [
    // {
    //     path: '/register',
    //     name: 'register',
    //     meta: {
    //         hideForAuth: true
    //     },
    //     // component: () => import(/* webpackChunkName: "Register" */ '../views/RegisterView')
    // },
    {
        path: '/login',
        name: 'login',
        meta: {
            hideForAuth: true
        },
        component: () => import(/* webpackChunkName: "Login" */ '../views/LoginView')
    },
    {
        path: '/reset-password',
        name: 'reset-password',
        meta: {
            hideForAuth: true
        },
        component: () => import(/* webpackChunkName: "ResetPassword" */ '../views/ResetPassword')
    },
    {
        path: '/',
        name: 'home',
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "HomeView" */ '../views/HomeView')
    },
    {
        path: '/profile',
        name: 'profile',
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "ProfileView" */ '../views/ProfileView')
    },
    {
        path: '/structures',
        name: 'structures',
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "StructureView" */ '../views/StructureView')
    },
    {
        path: '/structures/:id',
        name: 'detailStructure',
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "DetailStructure" */ '../views/DetailStructure')
    },
    {
        path: '/faqs',
        name: 'faqs',
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "FaqsView" */ '../views/FaqsView')
    },
    {
        path: '/operators',
        name: 'operators',
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "OperatorView" */ '../views/OperatorView')
    },
    {
        path: '/operators/:id',
        name: 'detailOperator',
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "DetailOperator" */ '../views/DetailOperator')
    },
    {
        path: '/admins',
        name: 'admins',
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "AdminsView" */ '../views/AdminsView')
    },
    {
        path: '/admins/:id',
        name: 'detailAdmin',
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "DetailAdmin" */ '../views/DetailAdmin')
    },
    {
        path: '/questions',
        name: 'questions',
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "QuestionView" */ '../views/QuestionView')
    },
    {
        path: '/reports',
        name: 'reports',
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "ReportView" */ '../views/ReportView')
    },
    {
        path: '/reports/:id',
        name: 'detailReport',
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "DetailReport" */ '../views/DetailReport')
    },
    {
        path: '/services',
        name: 'services',
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "ServiceView" */ '../views/ServiceView')
    },
    {
        path: '/services/:id',
        name: 'detailService',
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "DetailService" */ '../views/DetailService')
    },
    {
        path: '/needs',
        name: 'needs',
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "ServiceView" */ '../views/NeedView')
    },
    {
        path: '/needs/:id',
        name: 'detailNeed',
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "DetailService" */ '../views/DetailNeed')
    },
    {
        path: '/chronology',
        name: 'chronology',
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "ChronologyView" */ '../views/ChronologyView')
    },
    {
        path: '/welcome-cards',
        name: 'welcome-cards',
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "WelcomeCardView" */ '../views/WelcomeCardView')
    },
    {
        path: '/welcome-cards/:id',
        name: 'detailWelcomeCard',
        meta: {
            requiresAuth: true
        },
        component: () => import(/* webpackChunkName: "DetailReceptionCardView" */ '../views/DetailReceptionCardView')
    },
    {
        path: '/:pathMatch(.*)*',
        redirect: "/",
    }
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes
})


router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (useAuthStore().isAuthenticated) {
            next();
            return;
        }
        next("/login");
    } else {
        next();
    }
});


router.beforeEach((to, from, next) => {
    // l'utente operatore viene riportato alla home se prova ad accedere ai seguenti path
    if (useAuthStore().userGetters && useAuthStore().userGetters.user_type === 'o' &&
        ((to.name === 'services') || (to.name === 'structures') || (to.name === 'operators') || (to.name === 'admins') ||
            (to.name === 'chronology') || (to.name === 'questions'))) {
        next("/");
    } else {
        next()
    }
})

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.hideForAuth)) {
        if (useAuthStore().isAuthenticated) {
            next("/");
            return;
        }
        next();
    } else {
        next();
    }
});


export default router
